<template>
  <div class="wrapper">
    <div class="d-flex flex-wrap menu-wrapper">
      <div
        class="menu d-flex flex-column align-center pa-3 mt-4"
        v-for="(m, index) in menus"
        :key="m.type"
        @click="clickMenu(m)"
      >
        <v-badge
          v-if="index === 1" 
          :model-value="noneRead" 
          color="red"
          offset-x="30"
          offset-y="8"
          overlap
          small
        >
          <v-img
            class="mb-2"
            width="120"
            height="120"
            :src="m.img ?? undefined"
            contain
          ></v-img>
        </v-badge>

        <v-img
          v-else
          class="mb-2"
          width="120"
          height="120"
          :src="m.img ?? undefined"
          contain
        ></v-img>

      </div>
    </div>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from 'vue';
import { when } from '@/service/Switch';
import { familyModule } from '@/store/entityModules/family';
import { invoiceModule } from '@/store/entityModules/invoice';

enum MenuType {
  CHILDREN = 'children',
  PARENTINFO = 'parentinfo',
  REFERENCES = 'references',
  GROWTH = 'growth',
  INVOICE = 'invoice',
  SETTING = 'setting',
  INQUIRY = 'inquiry',
  HELP = 'help',
  // LOGOUT = 'logout',
}

interface Menu {
  type: MenuType;
  img: string;
  title: string;
  path: string;
}

interface DataType {
  noneRead: boolean;
  menus: Menu[];
}

export default defineComponent({

  data: (): DataType => ({
    noneRead: false,
    menus: [
      // {
      //   type: MenuType.CHILDREN,
      //   img: require('@/assets/children.png'),
      //   title: '児童票',
      //   path: '/children',
      // },
      // {
      //   type: MenuType.PARENTINFO,
      //   img: require('@/assets/parent.png'),
      //   title: '保護者票',
      //   path: '/parent/info',
      // },
      // {
      //   type: MenuType.REFERENCES,
      //   img: require('@/assets/parent.png'),
      //   title: '資料室',
      //   path: '/references',
      // },
      {
        type: MenuType.GROWTH,
        img: require('@/assets/growth.png'),
        title: '成長記録',
        path: '/growth/select',
      },
      {
        type: MenuType.INVOICE,
        img: require('@/assets/invoice.png'),
        title: '請求書',
        path: '/invoice/select',
      },
      {
        type: MenuType.SETTING,
        img: require('@/assets/cog.png'),
        title: '各種設定',
        path: '/setting/various',
      },
      // {
      //   type: MenuType.INQUIRY,
      //   img: 'https://via.placeholder.com/240x180?text=Sample+Image+1',
      //   title: 'お問い合わせ',
      //   path: '/inquiry',
      // },
      // {
      //   type: MenuType.HELP,
      //   img: 'https://via.placeholder.com/240x180?text=Sample+Image+1',
      //   title: 'ヘルプ',
      //   path: '/help',
      // },
      // {
      //   type: MenuType.LOGOUT,
      //   img: 'https://via.placeholder.com/240x180?text=Sample+Image+1',
      //   title: 'ログアウト',
      //   path: '/children',
      // },
    ],
  }),

  computed: {
    family() {
      return familyModule.family || null;
    },
  },

  methods: {
    clickMenu(menu: Menu) {
      this.$router.push(menu.path);
    },
  },
  async mounted() {
    this.noneRead = false;
    if (this.family) {
      const familyChildren = this.family.children;
      const invoicesLocal = invoiceModule.invoices;
      for (var i = 0; i < familyChildren.length; i++) {
        if (typeof familyChildren[i].childId === 'number') {
          const childId = familyChildren[i].childId;
          await invoiceModule.fetchInvoices({ childId: childId, year: null });
        }
        if (typeof familyChildren[i].childId === 'string') {
          const childId = Number(familyChildren[i].childId);
          await invoiceModule.fetchInvoices({ childId: childId, year: null });
        }
        if (invoiceModule.invoices) {
          for (var j = 0; j < invoiceModule.invoices.length; j++) {
            if (!invoiceModule.invoices[j].readDate) {
              this.noneRead = true;
              break;
            }
          }
          if (this.noneRead) {
            break;
          }
        }
      }
    }
  },
});
</script>
<style lang="scss" scoped>
.wrapper {
  @supports (bottom: env(safe-area-inset-bottom)) {
    padding-top: env(safe-area-inset-top);
  }

  .menu-wrapper {
    width: 100%;

    .menu {
      width: 50%;
    }
  }
}
</style>
